import { StarIcon } from 'assets/Icons';
import React from 'react';
interface StarProps {
  stars: number;
}

export const GoldStars: React.FunctionComponent<StarProps> = ({ stars }) => {
  return (
    <div className="text-base flex gap-2">
      {Array.from({ length: stars }, (_, i) => (
        <StarIcon fill="#F79009" key={i} className="w-6 h-6" />
      ))}
      {Array.from({ length: 5 - stars }, (_, i) => (
        <StarIcon fill="#D3D3D3" key={i} className="w-6 h-6" />
      ))}
    </div>
  );
};
